import {DatePicker, Space} from 'antd';
import {Dayjs} from 'dayjs';
import React from 'react';
import HourSelector from "@/components/Filters/HourSelector";
import moment from "moment/moment";

interface SameDayTimeRange {
  date: Dayjs | null;
  start: string | null;
  end: string | null;
}

const SameDayTimeRangePicker: React.FC<{
  value?: SameDayTimeRange;
  notBeforeToday?: boolean,
  includeToday?: boolean,
  notAfterToday?: boolean,
  onChange?: (value: SameDayTimeRange) => void;
}> = ({ value, onChange, notAfterToday, includeToday, notBeforeToday }) => {

  const {date, start, end} = value

  const handleChange = (field: 'date' | 'start' | 'end', val: any) => {
    const newState = {
      date,
      start,
      end,
      [field]: val,
    };
    onChange?.(newState);
  };


  const getDisabledDate = (current) => {
    let finalResult = false;

    if (includeToday && current && current.isSame(moment(), 'day')){
      return false
    }
    if (notAfterToday){
      finalResult = finalResult || (current && current > moment().endOf('day'))
    }
    if (notBeforeToday){
      finalResult = finalResult || (current && current <= moment().endOf('day'))
    }
    return finalResult
  }



  return (
    <Space>
      <DatePicker
        style={{ width: 200 }}
        value={date}
        onChange={(d) => handleChange('date', d)}
        allowClear
        size={"small"}
        disabledDate={getDisabledDate}
        variant={"underlined"}
      />
      <HourSelector to={end} value={start} onChange={time => handleChange('start', time)}/>
      <span> - </span>
      <HourSelector from={start} value={end} onChange={time => handleChange('end', time)}/>
    </Space>
  );
};

export default SameDayTimeRangePicker
